import { get } from 'api/get';

import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const VENDORS_LIST_REQUEST = 'vendors/list/request';
export const VENDORS_LIST_SUCCESS = 'vendors/list/success';
export const VENDORS_LIST_FAILURE = 'vendors/list/failure';

export const VENDOR_GET_FULFILMENT_HUBS_SUCCESS = 'vendors/fulfilment-hubs/get/success';
export const VENDOR_GET_FULFILMENT_HUBS_FAILURE = 'vendors/fulfilment-hubs/get/failure';

export const VENDOR_DETAILS_GET_REQUEST = 'vendors/details/get/request';
export const VENDOR_DETAILS_GET_SUCCESS = 'vendors/details/get/success';
export const VENDOR_DETAILS_GET_FAILURE = 'vendors/details/get/failure';

export const VENDOR_DETAILS_META_GET_SUCCESS = 'vendors/details/meta/get/success';
export const VENDOR_DETAILS_CLEAR = 'vendors/details/clear';
export const VENDOR_ONCHANGE_DETAILS = 'vendors/details/on-change';
export const VENDOR_ONCHANGE_INFO = 'vendors/details/on-change-info';

export const VENDOR_DETAILS_SAVE_REQUEST = 'vendors/details/save/request';
export const VENDOR_DETAILS_SAVE_SUCCESS = 'vendors/details/save/success';
export const VENDOR_DETAILS_SAVE_FAILURE = 'vendors/details/save/failure';

export const VENDOR_DETAILS_TOGGLE_CONFIRM_MODAL = 'vendors/details/toggle-confirm-modal';

export const VENDOR_TOGGLE_INACTIVE_REQUEST = 'vendors/toggleInactive/request';
export const VENDOR_TOGGLE_INACTIVE_SUCCESS = 'vendors/toggleInactive/success';
export const VENDOR_TOGGLE_INACTIVE_FAILURE = 'vendors/toggleInactive/failure';
export const VENDOR_TOGGLE_GLOBAL_INACTIVE_FILTER_SUCCESS = 'vendors/actions/set-filter/inactive/success';

export const VENDOR_TOGGLE_PARTNER_REQUEST = 'vendors/toggle-partner/request';
export const VENDOR_TOGGLE_PARTNER_SUCCESS = 'vendors/toggle-partner/success';
export const VENDOR_TOGGLE_PARTNER_FAILURE = 'vendors/toggle-partner/failure';

export const VENDORS_GET_VENDORS_BY_USER_REQUEST = 'VENDORS_GET_VENDORS_BY_USER_REQUEST';
export const VENDORS_GET_VENDORS_BY_USER_SUCCESS = 'VENDORS_GET_VENDORS_BY_USER_SUCCESS';
export const VENDORS_GET_VENDORS_BY_USER_FAILURE = 'VENDORS_GET_VENDORS_BY_USER_FAILURE';

export const IMPORT_VENDOR_DETAILS_REQUEST = 'IMPORT_VENDOR_DETAILS_REQUEST';
export const IMPORT_VENDOR_DETAILS_SUCCESS = 'IMPORT_VENDOR_DETAILS_SUCCESS';
export const IMPORT_VENDOR_DETAILS_FAILURE = 'IMPORT_VENDOR_DETAILS_FAILURE';

export const IMPORT_VENDOR_DETAILS_SAVE_REQUEST = 'IMPORT_VENDOR_DETAILS_SAVE_REQUEST';
export const IMPORT_VENDOR_DETAILS_SAVE_SUCCESS = 'IMPORT_VENDOR_DETAILS_SAVE_SUCCESS';
export const IMPORT_VENDOR_DETAILS_SAVE_FAILURE = 'IMPORT_VENDOR_DETAILS_SAVE_FAILURE';

export const DOWNLOAD_VENDOR_IMPORT_TEMPLATE_SUCCESS = 'DOWNLOAD_VENDOR_IMPORT_TEMPLATE_SUCCESS';
export const DOWNLOAD_VENDOR_IMPORT_TEMPLATE_FAILURE = 'DOWNLOAD_VENDOR_IMPORT_TEMPLATE_FAILURE';

export const RESET_IMPORT_VENDORS_SUCCESS = 'RESET_IMPORT_VENDORS_SUCCESS';
export const RESET_ATTACHED_VENDORS_TO_USER = 'RESET_ATTACHED_VENDORS_TO_USER';

export const VENDOR_PRODUCT_DETAILS_SAVE_REQUEST = 'VENDOR_PRODUCT_DETAILS_SAVE_REQUEST';
export const VENDOR_PRODUCT_SAVE_SUCCESS = 'VENDOR_PRODUCT_SAVE_SUCCESS';
export const VENDOR_PRODUCT_SAVE_FAILURE = 'VENDOR_PRODUCT_SAVE_FAILURE';
export const VENDOR_PRODUCTS_LIST_SUCCESS = 'VENDOR_PRODUCTS_LIST_SUCCESS';
export const VENDOR_PRODUCTS_LIST_FAILURE = 'VENDOR_PRODUCTS_LIST_FAILURE';
export const VENDOR_PRODUCT_DETAILS_SUCCESS = 'VENDOR_PRODUCT_DETAILS_SUCCESS';
export const VENDOR_PRODUCT_DETAILS_FAILURE = 'VENDOR_PRODUCT_DETAILS_FAILURE';
export const VENDOR_PRODUCT_DETAILS_SAVE_SUCCESS = 'VENDOR_PRODUCT_DETAILS_SAVE_SUCCESS';
export const VENDOR_PRODUCT_DETAILS_SAVE_FAILURE = 'VENDOR_PRODUCT_DETAILS_SAVE_FAILURE';
export const VENDOR_PRODUCT_UPLOAD_IMAGE_SUCCESS = 'VENDOR_PRODUCT_UPLOAD_IMAGE_SUCCESS';
export const VENDOR_PRODUCT_UPLOAD_IMAGE_FAILURE = 'VENDOR_PRODUCT_UPLOAD_IMAGE_FAILURE';
export const GET_VENDOR_PRODUCT_IMAGE_SUCCESS = 'GET_VENDOR_PRODUCT_IMAGE_SUCCESS';
export const GET_VENDOR_PRODUCT_IMAGE_FAILURE = 'GET_VENDOR_PRODUCT_IMAGE_FAILURE';
export const REMOVE_PRODUCT_IMAGE_SUCCESS = 'REMOVE_PRODUCT_IMAGE_SUCCESS';

export const VENDORS_GET_FILTERS_SUCCESS = 'vendors/filters/get/success';
export const VENDORS_GET_FILTERS_FAILURE = 'vendors/filters/get/failure';

export const VENDORS_SET_FILTERS_SUCCESS = 'vendors/filters/set/success';
export const VENDORS_SET_FILTERS_CLEAR = 'vendors/filters/clear/success';
export const SET_QUERY_VALUE = 'vendors/filters/set/query/value';

export const VENDOR_LOGO_UPLOAD_SUCCESS = 'VENDOR_LOGO_UPLOAD_SUCCESS';
export const VENDOR_LOGO_UPLOAD_FAILURE = 'VENDOR_LOGO_UPLOAD_FAILURE';

export const GET_VENDOR_LOGO_SUCCESS = 'GET_VENDOR_LOGO_SUCCESS';
export const GET_VENDOR_LOGO_FAILURE = 'GET_VENDOR_LOGO_FAILURE';

export function getVendorsList() {
  return async (dispatch, getState) => {
    dispatch({
      type: VENDORS_LIST_REQUEST,
      payload: null
    });

    try {
      const activeFilters = { ...getState().vendors.activeFilters };

      const requestOptions = {
        ...activeFilters
      };

      const req = await get('vendors', requestOptions);
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: VENDORS_LIST_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: VENDORS_LIST_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}
